import { render, staticRenderFns } from "./SubscriptionsNotPayed.vue?vue&type=template&id=ed1bc1c2"
import script from "./SubscriptionsNotPayed.vue?vue&type=script&lang=js"
export * from "./SubscriptionsNotPayed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports